export default __webpack_public_path__ + "locales/it/InfoPanel.json?hash=54e71a390be20ce2ec771a936272f7af";